import Main from './AssetInventoryMain'
import New from './AssetInventoryNew'
import Show from './AssetInventoryShow'
import Edit from './AssetInventoryEdit'

export default {
  Main,
  New,
  Show,
  Edit,
}
